import React from 'react';
import { HttpStatusCode } from '@cp/utils/const/httpStatusCode';
import { IReactAppNotFoundProps, ReactAppNotFoundType } from '@common/model/reactApp/error';
import { CatalogNotFound, NotFound } from 'src/widgets/notFound';
import { useHelmet } from 'src/shared/helmet';
import Header from 'src/widgets/header';
import { PageFooter } from 'src/app/shared/components/layout/components/footer';
import { useStaticRouterContext } from '../../shared/context/staticRouterContext/context';

const NotFoundPage: React.FC<IReactAppNotFoundProps> = ({ status, meta, providers, type = ReactAppNotFoundType.Catalog }) => {
  const Helmet = useHelmet();
  const staticRouterContext = useStaticRouterContext();
  const description = meta?.description ? meta.description : 'К сожалению, запрашиваемая страница не найдена.';

  if (staticRouterContext) {
    staticRouterContext.statusCode = status ?? HttpStatusCode.NotFound;
  }

  return (
    <div>
      <Helmet>
        <meta content={description} name="description" />
        <title>{status ? 'YouHelp' : 'Страница не найдена - YouHelp'}</title>
      </Helmet>
      <Header />
      {type === ReactAppNotFoundType.Primary && <NotFound />}
      {type === ReactAppNotFoundType.Catalog && <CatalogNotFound cityAlias={providers?.city} />}
      {providers?.footer && <PageFooter />}
    </div>
  );
};

export default NotFoundPage;
